"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFaqItemDto = instanceOfFaqItemDto;
exports.FaqItemDtoFromJSON = FaqItemDtoFromJSON;
exports.FaqItemDtoFromJSONTyped = FaqItemDtoFromJSONTyped;
exports.FaqItemDtoToJSON = FaqItemDtoToJSON;
exports.FaqItemDtoToJSONTyped = FaqItemDtoToJSONTyped;
/**
 * Check if a given object implements the FaqItemDto interface.
 */
function instanceOfFaqItemDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('slug' in value) || value['slug'] === undefined)
        return false;
    if (!('category' in value) || value['category'] === undefined)
        return false;
    if (!('question' in value) || value['question'] === undefined)
        return false;
    if (!('answer' in value) || value['answer'] === undefined)
        return false;
    return true;
}
function FaqItemDtoFromJSON(json) {
    return FaqItemDtoFromJSONTyped(json, false);
}
function FaqItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'slug': json['slug'],
        'category': json['category'],
        'question': json['question'],
        'answer': json['answer'],
    };
}
function FaqItemDtoToJSON(json) {
    return FaqItemDtoToJSONTyped(json, false);
}
function FaqItemDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'slug': value['slug'],
        'category': value['category'],
        'question': value['question'],
        'answer': value['answer'],
    };
}
